<div class="student" style="margin-bottom: 1.8rem;" (click)="studentClicked()">
  <!-- <div [ngClass]="stat!='pending' && stat==student_status && userId==loggedInUserId || stat!='pending' && student_status=='ADMIN'?'allowed':'notallowed'">   -->
  <div
    [ngClass]="stat!='pending' && stat==student_status && userId==loggedInUserId || student_status=='ADMIN'?'allowed':'notallowed'">
    <div class="outter">
      <div class="inner">
        <div *ngIf="hasCustomImage()" class="student-img" [style.backgroundImage]="'url('+ baseuUlr+response[i].students[j].image_path +')'">
        </div>
        <div *ngIf="!hasCustomImage()" class="student-img">
          <!-- Custom SVG placeholder - you can replace this with your desired SVG -->
          <img src="../../../assets/images/avatar.png" alt="">
        </div>
      </div>
    </div>
    <!-- <p >
      <span triggers="manual" #t="ngbTooltip" placement="bottom" tooltipClass="my-custom-class"
      [ngbTooltip]="studentInfoTemplate" (mouseover)="t.open()" (mouseout)="t.close()">
      <span class="studentName">{{response[i].students[j].name}}</span>
      </span>
    </p> -->
    <div #studentName class="studentName" [ngClass]="{'animate': isTextOverflowing}">
      <span class="textContent">{{ response[i].students[j].name }}</span>
  </div>
    <p style="color: #0074EC;" *ngIf="stat != 'pending' || response[i]?.grade?.gates_count == 1">
      <span triggers="manual" #x="ngbTooltip" placement="bottom" tooltipClass="my-custom-class"
        [ngbTooltip]="infoTemplate" (mouseover)="x.open()" (mouseout)="x.close()">
        <span class="gateName">{{response[i].students[j].requests ?
          response[i].students[j].requests[0].gate?.name:response[i].students[j].request[0].gate?.name}}</span>
      </span>
    </p>
    <ng-template #infoTemplate>
      <div class="info-container">
        <div>{{response[i].students[j].requests ?
          response[i].students[j].requests[0].gate?.name:response[i].students[j].request[0].gate?.name}}</div>
      </div>
    </ng-template>
    <ng-template #studentInfoTemplate>
      <div class="student-info-container">
        <div>{{response[i].students[j].name}}</div>
      </div>
    </ng-template>
  </div>
</div>